var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-wb-loading flex-center",style:(_vm.cssStyle)},[_c('img',{staticClass:"loading-icon",attrs:{"src":require("@/assets/loading_small.webp")}}),(_vm.desc)?_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }